import { AuthActionTypes } from './actions/auth.actions';
import * as reducers from './reducers';
import { ActionReducerMap, createSelector } from '@ngrx/store';

export interface AppState {
  auth: reducers.AuthState;
  user: reducers.UserState;
  orders: reducers.OrdersState;
  layout: reducers.LayoutState;
  search: reducers.SearchState;
  sort: reducers.SortState;
  print: reducers.PrintState;
  export: reducers.ExportState;
  location: reducers.LocationState;
  locations: reducers.LocationsState;
  kpi: reducers.KpiState;
}

export const selectState = createSelector(
  (state: AppState) => state,
  (state) => state,
);

export const selectLocation = createSelector(selectState, (state) => state.location);

export const selectLocationLocation = createSelector(selectLocation, (state) => state.location);

export const selectUser = createSelector(
  (state: AppState) => state.user,
  (user) => user,
);

export const selectUserProfile = createSelector(selectUser, (user) => user?.profile);

export const selectUserTheme = createSelector(selectUserProfile, (user) => user?.theme);

export const selectUserApplicationProfiles = createSelector(selectUserProfile, (user) => user.applicationProfiles);

export const selectKpi = createSelector(selectState, (state) => state.kpi);

export const selectKpiKpi = createSelector(selectKpi, (state) => state.kpi);

export const selectKpiCurrentLocation = createSelector(selectKpi, (state) => state.currentLocation);

export const selectKpiPending = createSelector(selectKpi, (state) => state.pending);

export const selectLocations = createSelector(
  (state: AppState) => state,
  (state) => state.locations,
);

export const selectOrdersErr = createSelector(
  (state: AppState) => state,
  (state) => state.orders.error,
);

export const INITIAL_STATE: AppState = {
  auth: reducers.AUTH_INITIAL_STATE,
  user: reducers.USER_INITIAL_STATE,
  orders: reducers.ORDERS_INITIAL_STATE,
  layout: reducers.LAYOUT_INITIAL_STATE,
  search: reducers.SEARCH_INITIAL_STATE,
  sort: reducers.SORT_INITIAL_STATE,
  print: reducers.PRINT_INITIAL_STATE,
  export: reducers.EXPORT_INITIAL_STATE,
  location: reducers.LOCATION_INITIAL_STATE,
  locations: reducers.LOCATIONS_INITIAL_STATE,
  kpi: reducers.KPI_INITIAL_STATE,
};

export const appReducer: ActionReducerMap<AppState> = {
  auth: reducers.authReducer,
  user: reducers.userReducer,
  orders: reducers.ordersReducer,
  layout: reducers.layoutReducer,
  search: reducers.searchReducer,
  sort: reducers.sortReducer,
  print: reducers.printReducer,
  export: reducers.exportReducer,
  location: reducers.locationReducer,
  locations: reducers.locationsReducer,
  kpi: reducers.kpiReducer,
};

export function clearState(reducer) {
  return function (state, action) {
    if (action.type === AuthActionTypes.LOGOUT) {
      state = INITIAL_STATE;
    }

    return reducer(state, action);
  };
}

export const routerStateConfig = {
  stateKey: 'router', // state-slice name for routing state
};

export * from './actions';
export * from './reducers';
